module.exports = __webpack_public_path__ + "img/q4.f933a7e4.png";